import { apiClient, tenantHub, unwrap } from './client';
import type { ApiEnvelope, Metering } from './types';

/**
 * B1 / F-TA-09 — metering surfaces. Entities-under-management and agent-case counts for the hub over
 * a period, broken down by spoke (the billing/metering meter key rides along). NEW cross-track
 * endpoint (Track A); degrades to a teaching empty state where it 404s. Read only.
 */

const enc = (s: string) => encodeURIComponent(s);

export interface MeteringQuery {
  from?: string;
  to?: string;
}

/** GET /v1/metering/{hub}?from=&to= */
export async function getMetering(q: MeteringQuery = {}): Promise<Metering> {
  const { data } = await apiClient.get<ApiEnvelope<Metering>>(`/v1/metering/${enc(tenantHub())}`, {
    params: { from: q.from, to: q.to },
  });
  const body = unwrap(data);
  return {
    hub: body?.hub ?? tenantHub(),
    period: { from: body?.period?.from ?? '', to: body?.period?.to ?? '' },
    entitiesUnderManagement: {
      total: body?.entitiesUnderManagement?.total ?? 0,
      bySpoke: body?.entitiesUnderManagement?.bySpoke ?? {},
    },
    agentCaseCount: {
      total: body?.agentCaseCount?.total ?? 0,
      bySpoke: body?.agentCaseCount?.bySpoke ?? {},
    },
    meterKey: body?.meterKey,
  };
}
